import { jsxs as i, jsx as o, Fragment as p } from "react/jsx-runtime";
import { as as r, at as h } from "../../vendor-Dd6qj6gJ.js";
import { forwardRef as x } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as l } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as e } from "../BaseIcon/index.js";
import '../../assets/index16.css';const f = "_checkboxWrapper_h34x1_1", k = "_checkbox_h34x1_1", _ = "_indicator_h34x1_37", c = {
  checkboxWrapper: f,
  checkbox: k,
  indicator: _
}, W = x(
  ({ children: t, labelRef: n, variant: a = "checkbox", ...s }, d) => {
    const m = r(d), b = r(n);
    return /* @__PURE__ */ i(
      h,
      {
        ...l(s),
        ref: b,
        inputRef: m,
        className: c.checkboxWrapper,
        "data-component": "Checkbox",
        children: [
          /* @__PURE__ */ o("div", { className: c.checkbox, "aria-hidden": !0, children: a === "visibility" ? /* @__PURE__ */ i(p, { children: [
            /* @__PURE__ */ o(e, { size: "md", color: "moon", icon: "visibility-checked" }),
            /* @__PURE__ */ o(e, { size: "md", color: "moon", icon: "visibility-unchecked" }),
            /* @__PURE__ */ o(e, { size: "md", color: "moon", icon: "visibility-indeterminate" })
          ] }) : /* @__PURE__ */ o("div", { className: c.indicator }) }),
          t
        ]
      }
    );
  }
);
export {
  W as Checkbox
};
